import { __decorate, __metadata } from "tslib";
import { SingletonService } from '@trp-dms-digital-shared/ds-ui-library-common';
let DSConfigurationService = class DSConfigurationService {
    constructor() {
        this._configurationMap = new Map();
        // Empty
    }
    addConfiguration(key, configuration) {
        this._configurationMap.set(key, configuration);
    }
    getConfiguration(key) {
        return this._configurationMap.get(key);
    }
};
DSConfigurationService = __decorate([
    SingletonService,
    __metadata("design:paramtypes", [])
], DSConfigurationService);
export { DSConfigurationService };
//# sourceMappingURL=digital-shared-configuration.service.js.map